import {BaseSelectProps, MenuItem, Select, SelectChangeEvent, Stack, Typography} from '@mui/material';
import {forwardRef, useState} from 'react';
import {STYLES} from './styles';

interface Options {
  label: string;
  value: string;
}

interface Props extends Omit<BaseSelectProps<string>, 'multiple' | 'inputRef'> {
  label?: string;
  maxWidth?: string;
  options?: Options[];
}

export const SelectField = forwardRef<HTMLSelectElement, Props>(
  ({label, maxWidth, sx, placeholder, onChange, value, options = [], ...props}, ref) => {
    const [internalValue, setInternalValue] = useState('');

    const handleChange = (event: SelectChangeEvent, child: React.ReactNode) => {
      setInternalValue(event.target.value);
      onChange?.(event, child);
    };

    const currentValue = value ?? internalValue;
    const showPlaceholder = !currentValue && placeholder;

    return (
      <Stack gap="10px" position="relative">
        {label && <Typography sx={STYLES.label}>{label}</Typography>}
        {showPlaceholder && <Typography sx={STYLES.placeholder}>{placeholder}</Typography>}
        <Select
          inputRef={ref}
          sx={{...STYLES.field, ...sx, maxWidth}}
          variant="outlined"
          value={currentValue}
          onChange={handleChange}
          {...props}
        >
          {options.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </Stack>
    );
  },
);
